// @flow

import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { prepaidResource, fetchPrepaid, selectCurrency } from '@gandi/billing';

import { selectOrgBU } from 'src/Layout/components/PreferencesWidget/modules/selectors';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { Contact, OrganizationFormData } from '../types';

export const useDefaultFormValues: (
  contact: Contact,
) => Partial<OrganizationFormData> = contact => {
  const dispatch = useDispatch();

  const shouldFetchPrepaid = useAppSelector(state =>
    prepaidResource.selectShouldFetchOne(state, contact?.id),
  );

  // orga BU
  const orgBU = useAppSelector(state =>
    contact?.id ? selectOrgBU(state, contact.id) : undefined,
  );
  const needsPrepaid = !!contact && !!orgBU;
  const isPendingPrepaid = needsPrepaid && shouldFetchPrepaid;

  // prepaid useEffect
  useEffect(() => {
    if (isPendingPrepaid && !!contact?.id) {
      dispatch(fetchPrepaid({ sharingId: contact.id }));
    }
  }, [dispatch, isPendingPrepaid, contact?.id]);

  const currency = useAppSelector(state =>
    contact?.id ? selectCurrency(state, { sharingId: contact?.id }) : undefined,
  );

  return {
    type: contact?.type,
    firstname: contact?.firstname,
    lastname: contact?.lastname,
    name: contact?.name,
    orgname: contact?.orgname,
    email: contact?.email,
    phone: contact?.phone,
    fax: contact?.fax,
    country: contact?.country,
    streetaddr: contact?.streetaddr,
    streetaddr2: contact?.streetaddr2,
    zip: contact?.zip,
    city: contact?.city,
    state: contact?.state,
    currency,
    siren: contact?.siren,
    vat_number: contact?.vat_number,
    routing_identifier: contact?.routing_identifier,
  };
};
